import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange } from "@angular/core";
import { Router } from "@angular/router";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { Event } from "../../../../../models/event";
import { EventType } from "../../../../../models/event-type";
import { Registration } from "../../../../../models/registration";
import { RegistrationControllerService } from "../../../../../services/registration-controller/registration-controller.service";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "registration-description",
  templateUrl: "./description-registration.component.html",
  providers: [RegistrationControllerService, ToastrService],
})
export class RegistrationDescriptionComponent extends TranslatedBaseError implements OnChanges {

  @Input() public registration: Registration = new Registration();
  @Input() public showRegistrationAdd: boolean;
  @Input() public serviceId: string;
  @Input() public showCancelButton = false;
  @Output() public modalClosedEvent = new EventEmitter();
  public active = true;
  public isLoading: boolean = false;
  public allRegistrations: Registration[];
  public serviceRegistrations: Registration[];
  public loadedServiceRegistrations: boolean = false;
  public loadedAllRegistrations: boolean = false;
  public filteredAllRegistrations: Registration[];
  public regShortName: string = "";

  constructor(private registrationController: RegistrationControllerService,
              public toastr: ToastrService,
              private router: Router, public translateService: TranslateService) {
              super(toastr, translateService);
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.registration && changes.registration.currentValue) {
      this.registration = changes.registration.currentValue;
    }
  }

  public addNewItem() {
    this.registration.name = this.registration.name.trim();
    this.registration.active = true;
    this.registration.shortName = this.registration.shortName.trim();
    if (!this.isLoading) {
      this.isLoading = true;
      this.registrationController.createRegistration(this.registration).subscribe(
        (data) => {
          this.isLoading = false;
          this.addRegistrationToService(data);
          this.router.navigate(["/services/" + this.serviceId + "/registrations/" + data.id]);
        },
        (error) => {
          this.isLoading = false;
          this.showErrorMessage(error);
        },
      );
    }
  }

  public onChange(active: boolean) {
    this.registration.active = active;
  }

  public saveRegistration() {
    this.registration.name = this.registration.name.trim();
    this.registration.shortName = this.registration.shortName.trim();
    this.registrationController.saveRegistration(this.serviceId, this.registration).subscribe(
      (data) => {
        this.responseSuccessful("Registration saved!");
        this.modalClosedEvent.emit(new Event(this.registration.id, EventType.Update));
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public addRegistrationToService(registration: Registration) {
    this.registrationController.addRegistrationToService(this.serviceId, registration.id).subscribe(
      () => {
        this.getServiceRegistrations(this.serviceId);
        this.responseSuccessful("Registration added to service!");
      },
      (error) => {
        this.init();
        return this.showErrorMessage(error);
      },
    );
  }

  public getServiceRegistrations(serviceId: string) {
    this.registrationController.getRegistrationsList(serviceId).subscribe(
      (data) => {
        this.serviceRegistrations = data;
        this.loadedServiceRegistrations = true;
        this.getAllRegistrations();
      },
      (error) => this.showErrorMessageWithTitle("Unable to get list of service registrations", error),
    );
  }

  public getAllRegistrations() {
    this.registrationController.getAllRegistrations().subscribe(
      (data) => {
        this.allRegistrations = data;
        this.loadedAllRegistrations = true;
        this.filterAllRegistrations();
      },
      (error) => this.showErrorMessageWithTitle("Unable to get list of all registrations", error),
    );
  }

  public filterAllRegistrations() {
    if (this.loadedAllRegistrations && this.loadedServiceRegistrations) {
      this.filteredAllRegistrations = _.differenceWith(this.allRegistrations, this.serviceRegistrations, _.isEqual);
    }
  }

  public init() {
    this.getServiceRegistrations(this.serviceId);
  }

  public deleteRegistration(isConfirmed: boolean) {
    if (isConfirmed) {
      this.registrationController.deleteRegistration(this.registration.id).subscribe(
        (data) => {
          this.responseSuccessful("Registration deleted!");
          this.modalClosedEvent.emit(new Event(this.registration.id, EventType.Delete));
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public cancel() {
    this.modalClosedEvent.emit(new Event(null, EventType.Cancel));
  }

  public closeLayer() {
    this.router.navigate(["/services/" + this.serviceId + "/registrations"]);
  }

  public nameChanged(value): void {
    this.regShortName = value;
    this.registration.shortName = this.regShortName.substring(0, 20);
  }

}
